import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { text } from '../../pages/view-service/Constants'
import { LOGOUT } from '../../app/authState'
import {
  DELETE_SERVICE_TYPE,
  DELETE_SERVICE_TYPE_ERROR,
  ERROR,
  GET_SERVICE_INFO,
  GET_SERVICE_INFO_AVAILABILITY_SUCCESS,
  GET_SERVICE_INFO_AVAILABILITY_VIEW_MODE_SUCCESS,
  GET_SERVICE_INFO_ERROR,
  GET_SERVICE_INFO_SUCCESS,
  RESET,
  RESET_DATA_FOR_EDIT_PROVIDER,
  SAVE_SERVICE,
  SAVE_SERVICE_ERROR,
  SAVE_SERVICE_SUCCESS,
  SET_CURRENT_SERVICE,
  SET_SAVE_SUCCESS,
  SET_SERVICE,
  SET_SERVICE_TYPE_LOADING_STATUS,
} from './ViewServiceConstants'

const initialState = {
  loading: false,
  saveSuccess: false,
  error: '',
  data: {},
  dataForNewProvider: {},
  dataForEditProvider: {},
  currentData: {},
  defaultServerErrorMessage: '',
}

export default function viewServiceReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case SAVE_SERVICE:
    case DELETE_SERVICE_TYPE:
    case GET_SERVICE_INFO:
      return {
        ...state,
        loading: true,
        saveSuccess: false,
      }
    case SAVE_SERVICE_SUCCESS:
      const currentData = { ...state.data }
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      currentData[action.extraData.ServiceTypeId] = action.extraData
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        data: { ...currentData, [action.extraData.ServiceTypeId]: action.payload.data },
        saveSuccess: true,
      }
    case GET_SERVICE_INFO_SUCCESS:
      const currentDataCopy = { ...state.data }
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      currentDataCopy[`${action.payload.ServiceTypeId}`] = action.payload
      return {
        ...state,
        loading: false,
        data: { ...currentDataCopy },
      }
    case GET_SERVICE_INFO_AVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        dataForNewProvider: { ...action.payload },
      }
    case GET_SERVICE_INFO_AVAILABILITY_VIEW_MODE_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        dataForEditProvider: { ...action.payload },
      }
    case SET_SERVICE_TYPE_LOADING_STATUS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: action.payload,
      }
    case SET_SAVE_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        saveSuccess: action.payload,
      }
    case SAVE_SERVICE_ERROR:
    case DELETE_SERVICE_TYPE_ERROR:
    case GET_SERVICE_INFO_ERROR:
    case ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case 'ServiceTypeNotFound':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'Service type')
            break
          case 'NameNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Service Type')
            break
          case 'DescriptionNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Service description')
            break
          case 'VisitTypeIntakeFormCountNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Intake forms')
            break
          case 'VisitTypeConsentFormCountNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Consent forms')
            break
          case 'NameNotUnique':
            message = getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, 'Service type')
            break
          case 'VisitTypeCostNotValid':
          case 'VisitTypeNameNotValid':
          case 'VisitTypeCancellationFeeNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
            break
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          case 'IntakeFormNotFound':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, text.INTAKE_FORM)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage,
      }
    }
    case SET_SERVICE:
      const currentDataServicesCopy = { ...state.data }
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      currentDataServicesCopy[action.payload.ServiceTypeId] = {
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        ...state.data[action.payload.ServiceTypeId],
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        ...action.payload,
      }
      return {
        ...state,
      }
    case SET_CURRENT_SERVICE:
      return {
        ...state,
      }
    case RESET:
      return {
        ...initialState,
      }
    case RESET_DATA_FOR_EDIT_PROVIDER:
      return {
        ...state,
        dataForEditProvider: [],
      }
    case LOGOUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
